export { default as GDMSecureLink } from './GDMSecureLink';

export type { GDMSecureLinkComponent, GDMSecureLinkProps } from './GDMSecureLink.type';
